import { render, staticRenderFns } from "./SelectArticle.vue?vue&type=template&id=7e41cdc0"
import script from "./SelectArticle.vue?vue&type=script&lang=js"
export * from "./SelectArticle.vue?vue&type=script&lang=js"
import style0 from "./SelectArticle.vue?vue&type=style&index=0&id=7e41cdc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports